import type { Questionnaire } from '../types';
export const ExampleQuestionnaire: Questionnaire = {
  questionList: [{
    tags: ['placeholder:Select a response', 'radio'],
    deprecatedAnswerOptions: [],
    answerOptions: [{
      metadata: {},
      answer: 'Pass',
      note: 'none'
    }, {
      metadata: {},
      answer: 'Fixed',
      note: 'none'
    }, {
      metadata: {},
      answer: 'Fail - needs more attention',
      note: 'none'
    }],
    questionValidations: [],
    id: '5263a9d0-da9e-4ffa-bee3-db9532aeacfe',
    question: 'Does the vehicle have enough charge to return back to operation?',
    type: 'select',
    answerLimit: 1,
    note: '',
    isRequired: {
      value: true
    },
    isDynamicGenerated: {
      value: false
    }
  }, {
    tags: ['placeholder:Select a response', 'radio'],
    deprecatedAnswerOptions: [],
    answerOptions: [{
      metadata: {},
      answer: 'Pass',
      note: 'none'
    }, {
      metadata: {},
      answer: 'Fixed',
      note: 'none'
    }, {
      metadata: {},
      answer: 'Fail - needs more attention',
      note: 'none'
    }],
    questionValidations: [],
    id: '182d4031-54e9-44e9-91e7-5f6410baf8d9',
    question: 'Is the SSD inserted & locked into place?',
    type: 'select',
    answerLimit: 1,
    note: '',
    isRequired: {
      value: false
    },
    isDynamicGenerated: {
      value: false
    }
  }, {
    tags: ['MIN_WORDS::'],
    deprecatedAnswerOptions: [],
    answerOptions: [],
    questionValidations: [],
    id: '151f4d70-98d3-4f0c-96ab-1cbf15c840ef',
    question: 'Comment (optional)',
    type: 'input',
    answerLimit: 1,
    note: '',
    isRequired: {
      value: false
    },
    isDynamicGenerated: {
      value: false
    }
  }, {
    tags: ['placeholder:Select a response', 'radio'],
    deprecatedAnswerOptions: [],
    answerOptions: [{
      metadata: {},
      answer: 'Pass',
      note: 'none'
    }, {
      metadata: {},
      answer: 'Fixed',
      note: 'none'
    }, {
      metadata: {},
      answer: 'Fail - needs more attention',
      note: 'none'
    }],
    questionValidations: [],
    id: 'b5e5f4af-ff1e-4944-8405-d198e649d85a',
    question: 'Is PC switch in on position ',
    type: 'select',
    answerLimit: 1,
    note: '',
    isRequired: {
      value: false
    },
    isDynamicGenerated: {
      value: false
    }
  }, {
    tags: ['placeholder:Select a response'],
    deprecatedAnswerOptions: [],
    answerOptions: [{
      metadata: {},
      answer: 'Pass',
      note: 'none'
    }, {
      metadata: {},
      answer: 'Fixed',
      note: 'none'
    }, {
      metadata: {},
      answer: 'Fail - needs more attention',
      note: 'none'
    }],
    questionValidations: [],
    id: '949d81b4-85a4-4914-bd6a-a5f96c30132e',
    question: 'Start the vehicle',
    type: 'select',
    answerLimit: 1,
    note: '',
    isRequired: {
      value: false
    },
    isDynamicGenerated: {
      value: false
    }
  }, {
    tags: [],
    deprecatedAnswerOptions: [],
    answerOptions: [],
    questionValidations: [],
    id: 'b707bdc5-01dd-48fa-99be-188267fab84d',
    question: 'Comments ( Optional )',
    type: 'input',
    answerLimit: 1,
    note: '',
    isRequired: {
      value: false
    },
    isDynamicGenerated: {
      value: false
    }
  }, {
    tags: [],
    deprecatedAnswerOptions: [],
    answerOptions: [{
      metadata: {},
      answer: 'Pass',
      note: 'none'
    }, {
      metadata: {},
      answer: 'Fixed',
      note: 'none'
    }, {
      metadata: {},
      answer: 'Fail - needs more attention',
      note: 'none'
    }],
    questionValidations: [],
    id: 'f1fed0d9-556e-4450-8440-0fddd6e60505',
    question: 'Verify AV stack is on',
    type: 'select',
    answerLimit: 1,
    note: '',
    isRequired: {
      value: false
    },
    isDynamicGenerated: {
      value: false
    }
  }, {
    tags: [],
    deprecatedAnswerOptions: [],
    answerOptions: [{
      metadata: {},
      answer: 'Pass',
      note: 'none'
    }, {
      metadata: {},
      answer: 'Fixed',
      note: 'none'
    }, {
      metadata: {},
      answer: 'Fail - needs more attention',
      note: 'none'
    }],
    questionValidations: [],
    id: '9441b541-632c-407a-ba0e-479945a2b7a3',
    question: 'Vehicle Exterior - AV Hardware',
    type: 'select',
    answerLimit: 1,
    note: '',
    isRequired: {
      value: false
    },
    isDynamicGenerated: {
      value: false
    }
  }, {
    tags: ['placeholder:Select a response'],
    deprecatedAnswerOptions: [],
    answerOptions: [{
      metadata: {},
      answer: 'Pass',
      note: 'none'
    }, {
      metadata: {},
      answer: 'Fixed',
      note: 'none'
    }, {
      metadata: {},
      answer: 'Fail - needs more attention',
      note: 'none'
    }],
    questionValidations: [],
    id: '6cb95de8-a238-4a39-8075-18c05a0d98f3',
    question: 'Vehicle Exterior - Body',
    type: 'select',
    answerLimit: 1,
    note: '',
    isRequired: {
      value: false
    },
    isDynamicGenerated: {
      value: false
    }
  }],
  topQuestionIdList: ['5263a9d0-da9e-4ffa-bee3-db9532aeacfe', '182d4031-54e9-44e9-91e7-5f6410baf8d9', 'b5e5f4af-ff1e-4944-8405-d198e649d85a', '949d81b4-85a4-4914-bd6a-a5f96c30132e', 'f1fed0d9-556e-4450-8440-0fddd6e60505', '9441b541-632c-407a-ba0e-479945a2b7a3', '6cb95de8-a238-4a39-8075-18c05a0d98f3'],
  followUpList: [{
    conditionList: [{
      conditionList: [{
        equationList: [{
          type: 'equals',
          questionId: '182d4031-54e9-44e9-91e7-5f6410baf8d9',
          answer: 'Pass'
        }]
      }]
    }, {
      conditionList: [{
        equationList: [{
          type: 'equals',
          questionId: '182d4031-54e9-44e9-91e7-5f6410baf8d9',
          answer: 'Fail - needs more attention'
        }]
      }]
    }, {
      conditionList: [{
        equationList: [{
          type: 'equals',
          questionId: '182d4031-54e9-44e9-91e7-5f6410baf8d9',
          answer: 'Fixed'
        }]
      }]
    }],
    questionIdList: ['151f4d70-98d3-4f0c-96ab-1cbf15c840ef'],
    questionId: '182d4031-54e9-44e9-91e7-5f6410baf8d9'
  }, {
    conditionList: [],
    questionIdList: ['b707bdc5-01dd-48fa-99be-188267fab84d'],
    questionId: '949d81b4-85a4-4914-bd6a-a5f96c30132e'
  }],
  name: 'Dummy checklist',
  questionnaireId: ''
};